module.exports = __webpack_public_path__ + "img/siemens.5eb0f0f2.jpg";